export default "__VITE_ASSET__DZ9am6GB__"